import React, { Component } from 'react';
import '../css/App.css';
import '../css/swagger-ui.css';
import SwaggerUI from 'swagger-ui';
import Config from '../organization_config.json';
import '../../node_modules/swagger-ui/dist/swagger-ui.css'

// https://editor.swagger.io/ to make changes without accientally publishing

class apiReference extends Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationConfig: null,
            definitionList: null,
            definitionLink: "https://api.swaggerhub.com/apis/kanbanzone.io/integrations-kanbanzone.io/1.3-oas3/swagger.json"
            //definitionLink: "https://api.swaggerhub.com/apis/kanbanzone.io/integrations-kanbanzone.io/1.0/swagger.json"
        };
        this.swaggerhub = this.swaggerhub.bind(this);
        this.getOrganizationData = this.getOrganizationData.bind(this);
        this.updateDefinitionLink = this.updateDefinitionLink.bind(this)
    }

    componentWillMount() {
        this.setState({
            organizationConfig:  Config.orgData,
        })
    }

    //componentDidUpdate() {
    componentDidMount() {
        SwaggerUI({
            domNode: document.getElementById("api-data"),
            url: this.state.definitionLink,
        })
    }

    swaggerhub(inputMethod, inputResource, inputParams) {
        let url = "";
        if (inputParams) {
            url = "https://api.swaggerhub.com/apis/" + inputResource + "?" + inputParams
        } else {
            url = "https://api.swaggerhub.com/apis/" + inputResource
        }

        return fetch(url, {
            method: inputMethod
        }).then(response => {
            if (response.ok) {
                return response.json()
            } throw new Error('There was an issue requesting the API')
        }).then(json => {
            return json
        })
    }

    getOrganizationData(organization) {
        let inputParams = "page=0&limit=10&sort=NAME&order=ASC";
        let inputResource = organization;

        this.swaggerhub('GET', inputResource, inputParams).then(response => {
            this.setState({
                definitionList: response.apis
            })
        })
    }

    updateDefinitionLink(newLink) {
        this.setState({
            definitionLink: newLink
        })
    }

    render() {

        return (
            <div id="api-data" className="doc-page" />
        );
    }
}

export default apiReference;